export const fr = {
  accountSettings: {
    menu: {
      edit_profile: 'Modifier le profil',
      cause_preferences: 'Préférences de causes',
      notification_preferences: 'Préférences de notifications',
      security_settings: 'Paramètres de sécurité',
      opportunity_preferences: "Préférences d'opportunités",
    },
    profileSettings: {
      profile_page_title: 'Paramètres › Profil',
      edit_profile: 'Modifier le profil',
      full_name_hint: "N'hésitez pas à utiliser votre nom préféré bien sûr.",
      full_name_placeholder: 'Entrez votre nom complet',
      department_label: 'Département',
      team_lead_question:
        'Gérez-vous ou dirigez-vous une équipe chez {{companyName}}?',
      location_label: 'Emplacement',
      job_title_label: 'Titre du poste',
      job_title_placeholder: 'Entrez votre titre de poste',
      about_placeholder: 'Parlez un peu de vous',
      update_profile: 'Mettre à jour le profil',
    },
    causePreferences: {
      page_title: 'Paramètres › Préférences de causes',
      heading: 'Préférences de causes',
      description:
        'Quelles causes souhaitez-vous soutenir à travers le bénévolat ?',
      max_causes_hint:
        'Pour nous aider à personnaliser votre expérience, nous vous recommandons de sélectionner un maximum de 5 causes',
      update_button: 'Mettre à jour le profil',
    },
    notificationPreferences: {
      page_title: 'Paramètres › Préférences de notifications',
      heading: 'Préférences de notifications',
      newsletter: {
        label: 'Newsletter',
        opt_in: "S'inscrire",
        opt_out: 'Se désinscrire',
      },
      nearby_event_updates: {
        label: "Mises à jour d'événements à proximité",
        description:
          'Recevez des mises à jour par e-mail sur les événements qui se déroulent près de chez vous en fonction de votre localisation',
        opt_in: "S'abonner",
        opt_out: 'Se désabonner',
      },
      cause_updates: {
        label: 'Mises à jour des causes',
        description:
          'Recevez des mises à jour par email concernant vos causes sélectionnées',
        opt_in: "S'inscrire",
        opt_out: 'Se désinscrire',
      },
      slack_updates: {
        label: 'Notifications Slack',
        description:
          'Recevez des notifications via Slack concernant des mises à jour importantes',
        opt_in: "S'inscrire",
        opt_out: 'Se désinscrire',
      },
      update_button: 'Mettre à jour les préférences',
    },
    securitySettings: {
      page_title: 'Paramètres › Sécurité',
      heading: 'Changer le mot de passe',
      description:
        'Veuillez entrer votre mot de passe actuel pour confirmer vos modifications',
      current_password: {
        label: 'Mot de passe actuel',
        placeholder: '•••••••',
      },
      new_password: {
        label: 'Nouveau mot de passe',
        placeholder: '•••••••',
        error_same: 'Le nouveau mot de passe doit être différent.',
      },
      confirm_password: {
        label: 'Confirmer le nouveau mot de passe',
        placeholder: '•••••••',
        error_match: 'Les mots de passe doivent correspondre.',
      },
      update_button: 'Mettre à jour le mot de passe',
      success_message: 'Mot de passe mis à jour avec succès',
    },
  },
}
